module.exports = __webpack_public_path__ + "media/images/city_img/j_2-23bad77452e5c687c1dc0ffb4f077666.jpg";